import { type RouteObject } from 'react-router'

import { CONNECT_URL } from 'features/connect/paths'
import { lazyComponent } from 'routes/lazy-route'

export const connectRoutes: RouteObject[] = [
  {
    path: CONNECT_URL,
    lazy: lazyComponent(
      () => import('features/connect/Container'),
      'ConnectPage',
    ),
  },
]
